export default function (theme) {
    return {
        MuiSelect: {
            styleOverrides: {
                selectMenu: {
                    whiteSpace: 'normal',
                    overflow: 'auto'
                },
            }
        }
    };
}